/** Ko-fi donations page for Riftbound DB. */
export const KOFI_URL = 'https://ko-fi.com/riftbounddb';
